import React from 'react';
import styles from './PageContent.scss';

const PageContent: React.StatelessComponent = ({ children }) => (
  <div className={styles.content}>{children}</div>
);

export default PageContent;
